import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

class ApplicationIcon extends Component {

    state = {
        appType: ""
    }

    render() {
        const { t } = this.props;

        let icon
        let name

        switch (this.props.appType) {
            case "airtable":
                icon = <img className="app-icon-image" src="/images/airtable.png" alt="" />
                break;
            case "alphavantage":
                icon = <img className="app-icon-image" src="/images/alphavantage.png" alt="" />
                break;
            case "asana":
                icon = <img className="app-icon-image" src="/images/asana.png" alt="" />
                break;
            case "defipulse":
                icon = <img className="app-icon-image" src="/images/defipulse.png" alt="" />
                break;
            case "docusign":
                icon = <img className="app-icon-image" src="/images/docusign.png" alt="" />
                break;
            case "facebook":
                icon = <img className="app-icon-image" src="/images/facebook.png" alt="" />
                break;
            case "finnhub":
                icon = <img className="app-icon-image" src="/images/finnhub.png" alt="" />
                break;
            case "googlegmail":
                icon = <img className="app-icon-image" src="/images/googlegmail.png" alt="" />
                break;
            case "google":
                icon = <img className="app-icon-image" src="/images/google.png" alt="" />
                break;
            case "googlecalendar":
                icon = <img className="app-icon-image" src="/images/googlecalendar.png" alt="" />
                break;
            case "googledocs":
                icon = <img className="app-icon-image" src="/images/googledocs.png" alt="" />
                break;
            case "googledrive":
                icon = <img className="app-icon-image" src="/images/googledrive.png" alt="" />
                break;
            case "googleforms":
                icon = <img className="app-icon-image" src="/images/googleforms.png" alt="" />
                break;
            case "googlesheets":
                icon = <img className="app-icon-image" src="/images/googlesheets.png" alt="" />
                break;
            case "hubspot":
                icon = <img className="app-icon-image" src="/images/hubspot.png" alt="" />
                break;
            case "linkedin":
                icon = <img className="app-icon-image" src="/images/linkedin.png" alt="" />
                break;
            case "mailchimp":
                icon = <img className="app-icon-image" src="/images/mailchimp.png" alt="" />
                break;
            case "microsoft":
                icon = <img className="app-icon-image" src="/images/microsoft.png" alt="" />
                break;
            case "msteams":
                icon = <img className="app-icon-image" src="/images/msteams.png" alt="" />
                break;
            case "onedrive":
                icon = <img className="app-icon-image" src="/images/onedrive.png" alt="" />
                break;
            case "salesforce":
                icon = <img className="app-icon-image" src="/images/salesforce.png" alt="" />
                break;
            case "sendgrid":
                icon = <img className="app-icon-image" src="/images/sendgrid.png" alt="" />
                break;
            case "shopify":
                icon = <img className="app-icon-image" src="/images/shopify.png" alt="" />
                break;
            case "simplyflows_schedule":
                icon = <img className="app-icon-image" src="/images/simplyflows_schedule.png" alt="" />
                break;
            case "simplyflows_convert":
                icon = <img className="app-icon-image" src="/images/simplyflows_convert.png" alt="" />
                break;
            case "simplyflows_crypto":
                icon = <img className="app-icon-image" src="/images/simplyflows_crypto.png" alt="" />
                break;
            case "simplyflows_delay":
                icon = <img className="app-icon-image" src="/images/simplyflows_delay.png" alt="" />
                break;
            case "simplyflows_finance":
                icon = <img className="app-icon-image" src="/images/simplyflows_finance.png" alt="" />
                break;
            case "simplyflows_input":
                icon = <img className="app-icon-image" src="/images/simplyflows.png" alt="" />
                break;
            case "simplyflows_sendemail":
                icon = <img className="app-icon-image" src="/images/simplyflows_sendemail.png" alt="" />
                break;
            case "simplyflows_sms":
                icon = <img className="app-icon-image" src="/images/simplyflows_sms.png" alt="" />
                break;
            case "simplyflows_filter":
                icon = <img className="app-icon-image" src="/images/simplyflows_filter.png" alt="" />
                break;
            case "simplyflows_foreach":
                icon = <img className="app-icon-image" src="/images/simplyflows_foreach.png" alt="" />
                break;
            case "simplyflows_merge":
                icon = <img className="app-icon-image" src="/images/simplyflows_merge.png" alt="" />
                break;
            case "simplyflows_pause":
                icon = <img className="app-icon-image" src="/images/simplyflows_pause.png" alt="" />
                break;
            case "simplyflows_stop":
                icon = <img className="app-icon-image" src="/images/simplyflows_stop.png" alt="" />
                break;
            case "slack":
                icon = <img className="app-icon-image" src="/images/slack.png" alt="" />
                break;
            case "smartsheet":
                icon = <img className="app-icon-image" src="/images/smartsheet.png" alt="" />
                break;
            case "toggltrack":
                icon = <img className="app-icon-image" src="/images/toggltrack.png" alt="" />
                break;
            case "trello":
                icon = <img className="app-icon-image" src="/images/trello.png" alt="" />
                break;
            case "twilio":
                icon = <img className="app-icon-image" src="/images/twilio.png" alt="" />
                break;
            case "twitter":
                icon = <img className="app-icon-image" src="/images/twitter.png" alt="" />
                break;
            case "wordpress":
                icon = <img className="app-icon-image" src="/images/wordpress.png" alt="" />
                break;
            case "sendinblue":
                icon = <img className="app-icon-image" src="/images/sendinblue.png" alt="" />
                break;
            case "mongodbatlas":
                icon = <img className="app-icon-image" src="/images/mongodbatlas.png" alt="" />
                break;
            case "simplyflows_email":
                icon = <img className="app-icon-image" src="/images/simplyflows.png" alt="" />
                break;
            case "simplyflows_megaverse":
                icon = <img className="app-icon-image" src="/images/simplyflows.png" alt="" />
                break;
            case "twitter":
                icon = <img className="app-icon-image" src="/images/twitter.png" alt="" />
                break;
            case "simplyflows_db":
                icon = <img className="app-icon-image" src="/images/simplyflows.png" alt="" />
                break;
            default:
                icon = <i className="fa fa-spinner app-icon-image" aria-hidden="true" />
                break;
        }

        if (this.props.onlyIcon) {
            return icon
        } else {
            name = this.props.name
            if (!name) {
                name = t(this.props.appType)
            }
            return (
                <table width="300">
                    <tbody>
                        <tr><td width="84">
                            <div className={this.props.className}>
                                {icon}
                            </div>
                        </td><td className="large-icon-div">
                                {name}</td>
                        </tr>
                    </tbody>
                </table>
            )
        }
    }
}

export default withTranslation()(ApplicationIcon)